import { useEffect, useMemo } from "react";

const COLORS = [
  { color: "#25283d", ink: "#fff" },
  { color: "#b8d9f2", ink: "#193f60" },
  { color: "#a9d5c3", ink: "#214c3c" },
  { color: "#d1bde8", ink: "#51386e" },
  { color: "#ecd196", ink: "#634b1c" },
  { color: "#e6b3b0", ink: "#653735" },
  { color: "#b5dce0", ink: "#24535a" },
  { color: "#e7c1a5", ink: "#633f24" },
];

export default function useDepartmentColors(departments, uid) {
  const storageKey = `insights:department-colors:${uid || "anonymous"}`;
  const registry = useMemo(() => {
    let saved = [];
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || "[]");
      if (Array.isArray(stored))
        saved = stored.filter((name) => typeof name === "string");
    } catch {
      /* Use the current department list if browser storage is unavailable. */
    }
    return [...new Set([...saved, ...[...departments].sort()])];
  }, [departments, storageKey]);
  useEffect(() => {
    if (!registry.length) return;
    try {
      localStorage.setItem(storageKey, JSON.stringify(registry));
    } catch {
      /* Storage may be disabled. */
    }
  }, [registry, storageKey]);
  return new Map(
    registry.map((name, index) => [name, COLORS[index % COLORS.length]]),
  );
}
